import { TOGGLE_USER_SETTINGS_DROPDOWN } from "constants/actionTypes"

export const toggleUserSettingsDropdown = () => ({
	type: TOGGLE_USER_SETTINGS_DROPDOWN
})
